// Where every floating layer (dialog, sheet, tooltip, popover, menu, select)
// teleports to: one element of our own at the end of <body>, never <body>
// itself.
//
// Password managers watch <body>'s children and keep their own elements last.
// Bitwarden's inline menu moves whatever the page appends after its button to
// just before it. Vue removes a teleport's content by walking the nodes between
// two anchors it left in the target, so a node moved out from between them is
// never removed: a dialog closed with Cancel stayed on screen and could not be
// closed, a tooltip outlived its trigger and the page, and a dialog's overlay
// landed above its panel. Inside this element nothing the page mounts changes
// <body>'s children, so there is nothing for an extension to move; moving the
// element itself takes the anchors with it.
export const LAYER_ROOT_ID = "kn-layers";

export function layerRoot(): HTMLElement {
  const existing = document.getElementById(LAYER_ROOT_ID);
  if (existing) return existing;
  const el = document.createElement("div");
  el.id = LAYER_ROOT_ID;
  document.body.appendChild(el);
  return el;
}
